import React from 'react';

const defaultContext = Object.freeze({});
export const PrayerHubContext = React.createContext(defaultContext);
